export let getUserMedia:
  | Navigator['mediaDevices']['getUserMedia']
  | Navigator['getUserMedia']
  | Navigator['webkitGetUserMedia']
  | null = null;

if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  // navigator.mediaDevices.getUserMedia has a promise-based API,
  // unlike the deprecated methods
  getUserMedia = (
    constraints: MediaStreamConstraints,
    successCallback: NavigatorUserMediaSuccessCallback,
    errorCallback: NavigatorUserMediaErrorCallback,
  ) => {
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(successCallback)
      .catch(errorCallback);
  };
} else if (navigator.getUserMedia) {
  getUserMedia = navigator.getUserMedia.bind(
    navigator,
  ) as Navigator['getUserMedia'];
} else if (navigator.webkitGetUserMedia) {
  getUserMedia = navigator.webkitGetUserMedia.bind(
    navigator,
  ) as Navigator['webkitGetUserMedia'];
}
